/* global tracking */
'use strict';
const get = require('lodash/get');
const AnalyticsTrackingService = require('public/js/lib/analytics-track');
const GtagTrackingService = require('public/js/lib/gtag-track');

const track = {
	debug: false,
	trackers: {},
	transaction: null
};

var _gaq = _gaq || [];
var TrackingService = null;

track.init = function () {
	TrackingService = tracking.google.use_gtag_analytics ? GtagTrackingService : AnalyticsTrackingService;
	TrackingService.init();
};

track.track_event = function (event_args, options, name) {
	TrackingService.track_event(event_args, options, name);
};

track.track_transaction = function (name) {
	TrackingService.track_transaction(name);
};

track.track_pageview_all_trackers = function() {
	TrackingService.track_pageview_all_trackers();

	if (rp_app.env.google_analytics_enabled) {
		this.rp_track_pageview('rp-reporting', tracking.page || 'other');
	}
};

track.track_ec_impressions = function() {
	TrackingService.track_ec_impressions();
};

track.track_ec_cart_event = function(eventName, product_details) {
	TrackingService.track_ec_cart_event(eventName, product_details);
};

track.page_tracking = function (pageType) {
	TrackingService.page_tracking(pageType);
};

track.rp_track_pageview = function(name, page) {
	if (!tracking['rp-reporting']['enabled']) { return; }

	if (!page || page.indexOf('product') !== 0) { return; }

	const type = get(tracking, 'google.page_type');

	let product = null;
	if (tracking.products) {
		product = tracking.products[0];
	}

	$ajax({
		type: 'POST',
		url: '/ajax/rp-reporting/page-event',
		dataType: 'json',
		data: {
			type: type,
			sku: product ? product.product_id : null,
			catalog: product ? product.catalog : null
		}
	});
};

module.exports = track;
